export default __webpack_public_path__ + "static/media/ic_check.9066cd0c.svg";